import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'
import { supabase } from '../lib/supabase'

const Context = createContext({ rows: [], available: false, error: '', has: () => false, set: async () => { throw new Error('Preferences unavailable') } })
export const useProductPreferences = () => useContext(Context)
export function ProductPreferencesProvider({ userId, children }) {
  const [rows, setRows] = useState([])
  const [available, setAvailable] = useState(false)
  const [rowsOwner,setRowsOwner] = useState(null)
  const visibleRows = rowsOwner === userId && available ? rows : []
  const ownerAvailable = rowsOwner === userId && available
  const [error, setError] = useState('')
  const generation = useRef(0)
  const refresh = useCallback(async () => {
    const version = ++generation.current
    if (!userId) { setRows([]); setAvailable(false); return }
    const result = await supabase.from('product_preferences').select('kind,subject,enabled').eq('user_id',userId)
    if (version !== generation.current) return
    setRowsOwner(userId)
    setAvailable(!result.error)
    setError(result.error ? 'Preferences are temporarily unavailable.' : '')
    setRows(result.error ? [] : result.data || [])
  },[userId])
  useEffect(() => {
    setRows([]); setAvailable(false); refresh()
    const focus = () => refresh()
    window.addEventListener('focus',focus)
    return () => { generation.current++; window.removeEventListener('focus',focus) }
  },[refresh])
  const set = async (kind,subject,enabled) => {
    const version = generation.current
    if (!userId || !ownerAvailable) throw new Error('Preferences are temporarily unavailable.')
    const { error } = await supabase.from('product_preferences').upsert({ user_id:userId,kind,subject,enabled,updated_at:new Date().toISOString() },{onConflict:'user_id,kind,subject'})
    if (error) throw new Error('Could not save your preference. Please try again.')
    if (version === generation.current) setRows(current => [...current.filter(row => row.kind !== kind || row.subject !== subject),{kind,subject,enabled}])
  }
  return <Context.Provider value={{ rows:visibleRows,available:ownerAvailable,error,refresh,set,has:(kind,subject) => visibleRows.some(row=>row.kind===kind && row.subject===subject && row.enabled) }}>{children}</Context.Provider>
}
